import Vue from 'vue'
import Vuex from 'vuex'

// import { alert } from './alert.module'
import { account } from './account.module'
import { stats } from './stats.module'
import { comparison } from './comparison.module'
import { hashtagSets } from './hashtagsets.module'
import { reports } from './reports.module'
// import { users } from './users.module'

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {
        bannedInstagramHashtags: []
    },
    getters: {
        getBannedHashtags: state => {
            return state.bannedInstagramHashtags
        }
    },
    modules: {
        // alert,
        account,
        stats,
        comparison,
        hashtagSets,
        reports
    }
})
